import { useLocation, useMatches } from '@tanstack/react-router';

/**
 * The pathname the Outlet is actually rendering.
 *
 * `useLocation()` flips to the target URL the moment a navigation starts, while
 * `<Outlet/>` keeps rendering the current matches until the new route has loaded
 * (the router writes location and matches to separate stores). Anything that
 * picks a provider tree from the pending location renders the OLD page under the
 * NEW tree for that window — e.g. OwnerDashboard under PublicLayout, with no
 * ClerkAuthProvider above it, which throws `useAuth must be used within
 * ClerkAuthProvider`. Matches are the store the Outlet renders from, so the tree
 * and the page it wraps always flip together.
 *
 * Use this — not `useLocation()` — whenever a pathname decides which providers
 * mount around the Outlet.
 */
export function useRenderedPathname(): string {
  const location = useLocation();
  const matches = useMatches();
  return matches[matches.length - 1]?.pathname ?? location.pathname;
}
